import React from 'react';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Header from './layouts/Header';
import Footer from './layouts/Footer';
import AppRoutes from './routes/AppRoutes';
import ScrollToTop from './utils/ScrollToTop';
import StickyCTA from './components/StickyCTA';

function App() {
  return (
    <Box display="flex" minHeight="100vh" flexDirection="column">
      <ScrollToTop />
      <Header />
      <Box component="main" sx={{ flexGrow: 1 }}>
        <Container maxWidth="lg" sx={{ py: 3 }}>
          <AppRoutes />
        </Container>
      </Box>
      <Footer />
      <StickyCTA />
    </Box>
  );
}

export default App;
